<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action
      list-type="picture-card"
      :show-file-list="false"
      :http-request="uploadHttp"
      accept="image/*"
      :before-upload="beforeUpload"
    >
      <img v-if="url" :src="url" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>
<script>

import uploadMixin from './mixin'

export default {
  mixins: [ uploadMixin ],
  props: {
    url: {
      type: String,
    }
  },
}
</script>

<style lang="less" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>